import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import type { ComponentPropsWithoutRef } from 'react';

export type ExternalLinkIconProps = ComponentPropsWithoutRef<typeof ArrowTopRightOnSquareIcon>;

export function ExternalLinkIcon({
  className = 'h-4 w-4',
  ...props
}: ExternalLinkIconProps): React.JSX.Element {
  return (
    <ArrowTopRightOnSquareIcon
      {...props}
      className={className}
      aria-hidden={props['aria-hidden'] ?? true}
    />
  );
}
